import React from "react";

import { useHistory } from "react-router-dom";

import { ClientId, PortfolioPlanId } from "@fartherfinance/frontend/api/Types";

import { typedKeys } from "@src/multiCustodian/utils/arrayHelpers";

import styles from "./Tabs.module.css";

const TABS = {
  Accounts: "Accounts",
  ModelDetails: "Model Details",
} as const;

export type TabKey = keyof typeof TABS;

type TabsProps = {
  portfolioPlanId: PortfolioPlanId;
  clientId: ClientId;
  setCurTab?: (tab: TabKey) => void;
  curTab: TabKey;
};

const ModelTab = ({
  portfolioPlanId,
  clientId,
  curTab,
  setCurTab,
}: TabsProps): JSX.Element => {
  const history = useHistory();

  const handleSetTab = (tab: TabKey) => {
    setCurTab?.(tab);

    history.push({
      ...history.location,
      pathname: `/Client/${clientId}/Investments/PortfoliosV2/${portfolioPlanId}/${tab}`,
    });
  };

  return (
    <div className={styles.tabsContainer}>
      {typedKeys(TABS).map((tabKey) => (
        <p
          key={tabKey}
          className={curTab === tabKey ? styles.tabSelected : styles.tab}
          onClick={() => handleSetTab(tabKey)}
        >
          {TABS[tabKey]}
        </p>
      ))}
    </div>
  );
};

export default ModelTab;
